<template>
    <li class="nav-item dropdown">
        <slot></slot>
    </li>
</template>
